import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.updateAnswerSheetConfirmation.title',
    defaultMessage: 'ATUALIZAÇÃO DO CARTÃO-RESPOSTA',
  },
  singularSubtitle: {
    id: 'simulated.updateAnswerSheetConfirmation.singularSubtitle',
    defaultMessage: 'Cartão-resposta foi carregado com sucesso.',
  },
  pluralSubtitle: {
    id: 'simulated.updateAnswerSheetConfirmation.pluralSubtitle',
    defaultMessage: 'Foram carregados {amount} cartões-resposta com sucesso!',
  },
  close: {
    id: 'simulated.updateAnswerSheetConfirmation.close',
    defaultMessage: 'Fechar',
  },
  errorAlreadyExists: {
    id: 'simulated.updateAnswerSheetConfirmation.errorAlreadyExists',
    defaultMessage: 'Já existe uma correção para este aluno.',
  },
  errorStudentNotFound: {
    id: 'simulated.updateAnswerSheetConfirmation.errorStudentNotFound',
    defaultMessage: 'Aluno não encontrado',
  },
  errorPermissionDenied: {
    id: 'simulated.updateAnswerSheetConfirmation.errorPermissionDenied',
    defaultMessage:
      'Este usuário não tem permissão para carregar cartões-resposta para esta escola.',
  },
  errorGeneric: {
    id: 'simulated.updateAnswerSheetConfirmation.errorGeneric',
    defaultMessage: 'Por favor, informe pelo menos uma resposta para poder salvar as alterações.',
  },
  errorScan: {
    id: 'simulated.updateAnswerSheetConfirmation.errorScan',
    defaultMessage: 'Erro na leitura, por favor entre em contato com o administrador.',
  },
  errorFileNotSupported: {
    id: 'simulated.updateAnswerSheetConfirmation.errorFileNotSupported',
    defaultMessage:
      'Tipo de arquivo não suportado. Apenas arquivos .jpg e .png podem ser carregados.',
  },
  successMessage: {
    id: 'simulated.updateAnswerSheetConfirmation.successMessage',
    defaultMessage: 'Cartão-resposta foi carregado com sucesso.',
  },
});
